import React, { useState } from 'react'
import { useEffect } from 'react'
import { MotifButton, MotifProgressLoader } from '@ey-xd/motif-react'

import styles from './index.module.scss'


export const Logout: React.FC = () => {  
  const [success, setSuccess] = useState(false);

  const logoutAction = async () => {
    localStorage.clear()
    sessionStorage.clear() 
    setTimeout(() => {
      sessionStorage.removeItem('msal.interaction.status');
    }, 100); // Delay to ensure MSAL operations are complete
  }

  useEffect(() => {
    logoutAction()

    setTimeout(() => {
      setSuccess(true);
    }, 3000);
  }, [])

  return success ? (
    <div className={styles.container}>
      <p className="motif-h1">You have been logged out.</p>
      <a href="/" className="motif-text-link" title="retry">
        <MotifButton 
        variant="primary" 
        size="medium">Login</MotifButton>
      </a>
    </div>
  ) : (
    <div className={styles.container}>
      <p className="motif-h1">Logging out...</p>
      <MotifProgressLoader show={true} />
    </div>
  );
}
